<template>

  <PageHeader :disabled="accounts.length === 0"
              search-text="Spheres" @search="setSearch" @sort="setSort"
              @sort-order="setSortOrder"
  >
  </PageHeader>

  <ProgressSpinnerContainer v-if="accountsLoading" style="padding: 5em;"/>
  <SphereAccordion @enterSphere="enterSphere" :search-text="searchText" v-if="accounts.length" :spheres="sortedSpheres"></SphereAccordion>

</template>

<script setup>
import { computed } from "vue";
import PageHeader from "../components/PageHeader.vue";
import ProgressSpinnerContainer from "../components/ProgressSpinnerContainer.vue";
import SphereAccordion from "../components/SphereAccordion.vue";
import { useAccounts } from "../composables/entities.js";
import { useSort } from "../composables/ui.js";

const { accounts, accountsLoading } = useAccounts();

const emit = defineEmits([
    'enterSphere'
])

function enterSphere() {
  emit('enterSphere')
}

const spheres = computed(() => {
  const sphereHierarchy = {}
  const spheresById = {}
  const a = accounts.value
  if (!a?.length) {
    return []
  }
  for (const item of a) {
    spheresById[item.id] = {
      name: item.name,
      id: item.id,
      parentId: item.parentId,
      children: [],
    }
  }

  a.forEach(item => {
    const parentId = item.parentId;
    if (parentId) {
      const parent = spheresById[parentId];
      if (parent) {
        parent.children.push(spheresById[item.id]);
      }
      else {
        sphereHierarchy[item.id] = spheresById[item.id];
      }
    }
    else {
      sphereHierarchy[item.id] = spheresById[item.id];
    }
  });

  return Object.values(sphereHierarchy)
})

const { searchText, setSearch, selectedSort, setSort, sortOrder, setSortOrder } = useSort();

function sphereSearchResults(a, text, nest = 0) {
  if (!text || !a?.length) {
    return a
  }

  return a?.reduce((acc, a) => {
    const ch = sphereSearchResults(a?.children, text, nest + 1)
    if (ch?.length) {
      acc.push({ ...a, children: ch })
    }
    else if (a?.name?.toLowerCase()?.includes(text)) {
      acc.push({ ...a, children: [] })
    }
    return acc;
  }, [])
}

const sortedSpheres = computed(() => {
  return sphereSearchResults(spheres.value, searchText.value.toLowerCase()).sort((a, b) => {
    if (selectedSort.value?.code === 'date') {
      if (sortOrder.value === 'asc') {
        return a.created > b.created ? 1 : (b.created > a.created ? -1 : 0)
      }
      return a.created < b.created ? 1 : (b.created < a.created ? -1 : 0)
    }
    if (selectedSort.value?.code === 'alphabetical') {
      if (sortOrder.value === 'asc') {
        return a.name > b.name ? 1 : (b.name > a.name ? -1 : 0)
      }
      return a.name < b.name ? 1 : (b.name < a.name ? -1 : 0)
    }
  })
})

</script>

<style scoped>

</style>